import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Box, Paper } from "@mui/material";
import { useQuickStart } from "@/pages/organizations/detail/quick-start";
import GuideStepper from "@/features/guides/components/quick-start/GuideStepper";
import StepOne from "@/features/guides/components/quick-start/Step1";

export const Route = createFileRoute("/app/organizations/$organizationId/quick-start/subtopics/$subtopicId/")({
  component: RouteComponent,
});

const steps = ["Select Topic", "Answer Questions", "Get Your Guide"];

function RouteComponent() {
  const { subtopicId: urlSubtopicId } = Route.useParams();

  const {
    subtopicId,
    setSubtopicId,
    guides,
    setSelectedTopicId,
    setCurrentGuideId,
    currentQuestionIndex,
    refreshLinkedCriteria,
    navigateToStepZero,
    navigateToStepTwo,
  } = useQuickStart();

  const activeStep = 1;
  const isStepSkipped = () => false;

  // Sync subtopicId from URL
  useEffect(() => {
    const numericSubtopicId = Number(urlSubtopicId);
    if (numericSubtopicId && numericSubtopicId !== subtopicId) {
      setSubtopicId(numericSubtopicId);
    }
  }, [urlSubtopicId, subtopicId, setSubtopicId]);

  // Set topic/guide info once we have subtopicId and guides loaded
  useEffect(() => {
    if (!subtopicId || guides.length === 0) return;

    const guide = guides.find((g) => g.criterion_subtopic_id === subtopicId);
    if (guide) {
      setSelectedTopicId(guide.criterion_topic.id);
      setCurrentGuideId(guide.id ?? undefined);
    }
  }, [subtopicId, guides, setSelectedTopicId, setCurrentGuideId]);

  // Load linked criteria when entering step 1 and refresh on each question step change
  useEffect(() => {
    if (subtopicId) {
      refreshLinkedCriteria();
    }
  }, [currentQuestionIndex, subtopicId, refreshLinkedCriteria]);

  if (!subtopicId) {
    return null; // Wait for subtopicId to be set from URL
  }

  return (
    <Box>
      <Paper variant="elevation" elevation={5}>
        <GuideStepper
          activeStep={activeStep}
          handleBack={navigateToStepZero}
          steps={steps}
          isStepSkipped={isStepSkipped}
        />
        <StepOne onBack={navigateToStepZero} onNext={navigateToStepTwo} />
      </Paper>
    </Box>
  );
}
